module.exports = __webpack_public_path__ + "media/initiative-check.003059c1.mp3";